"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyCircle = exports.FilledCircle = void 0;
var React = require("react");
var generic_1 = require("./generic");
var FilledCircle = (function (_super) {
    __extends(FilledCircle, _super);
    function FilledCircle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilledCircle.prototype.render = function () {
        return (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "fas", size: "xs" }));
    };
    return FilledCircle;
}(React.Component));
exports.FilledCircle = FilledCircle;
var EmptyCircle = (function (_super) {
    __extends(EmptyCircle, _super);
    function EmptyCircle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyCircle.prototype.render = function () {
        return (React.createElement(generic_1.Icon, { name: generic_1.Icons.circle, prefix: "far", size: "xs" }));
    };
    return EmptyCircle;
}(React.Component));
exports.EmptyCircle = EmptyCircle;
